/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {FcVirtualScrollerComponent} from './fc-virtual-scroller.component';
import {FC_VIRTUAL_SCROLLER_DEFAULT_OPTIONS_FACTORY} from './fc-virtual-scroller-default-options.factory';


/**
 * FC Virtual Scroller Module.
 */
@NgModule({
    declarations: [
        FcVirtualScrollerComponent
    ],
    exports: [
        FcVirtualScrollerComponent
    ],
    imports: [
        CommonModule
    ],
    providers: [
        {
            provide: 'fc-virtual-scroller-default-options',
            useFactory: FC_VIRTUAL_SCROLLER_DEFAULT_OPTIONS_FACTORY
        }
    ]
})
export class FcVirtualScrollerModule {
}
